import {ProductListFilter} from "./ProductListFilter";
import {ProductListRequestHandler} from "./ProductListRequestHandler";
import {IItemContent, IItemSearchResponse} from "../items/interface/Item.interface";
import {IQueryData, ProductListOrder, ProductListOrderBy} from "../items/ItemSearchQuery";

/**
 * Class ProductListHandler
 * New this class when user enter to a product list pages
 * Remember to run `send()` right after create class to get all available filters.
 */
export class ProductList {
  public static PRODUCT_LIST_DEFAULT_LIMIT: number = 16;

  public readonly filter: ProductListFilter;

  public items: IItemContent[] = [];

  public total: number = 0;

  public offset: number = 0;

  public limit: number;

  public userId: string | undefined;

  public orderBy?: ProductListOrderBy;

  public order?: ProductListOrder;

  private readonly shopId: number;

  private readonly categoryId: number;

  private readonly currencyCode: string;

  private readonly customerId: number | undefined;

  private readonly customerGroupId: number | undefined;

  public constructor(
    shopId: number,
    categoryId: number,
    currencyCode: string,
    limit: number = ProductList.PRODUCT_LIST_DEFAULT_LIMIT,
    customerId?: number,
    customerGroupId?: number,
  ) {
    this.shopId = shopId;
    this.categoryId = categoryId;
    this.currencyCode = currencyCode;
    this.filter = new ProductListFilter();
    this.limit = limit;
    this.customerId = customerId;
    this.customerGroupId = customerGroupId;
  }

  public set page(page: number) {
    this.offset = page * this.limit;
  }

  public get page(): number {
    return Math.round(this.offset / this.limit) + 1;
  }

  public get isLastPage(): boolean {
    return this.offset >= this.total - this.limit;
  }

  /**
   * Get request params
   */
  public get requestParams(): IQueryData {
    return {
      categoryId: this.categoryId,
      currencyCode: this.currencyCode,
      limit: this.limit,
      offset: this.offset,
      orderBy: this.orderBy,
      order: this.order,
      customerId: this.customerId,
      customerGroupId: this.customerGroupId,
      userId: this.userId,
      ...this.filter.requestParams,
    };
  }

  /**
   * Send request to get product list data depending on the current filter conditions.
   */
  public async send(): Promise<IItemSearchResponse> {
    const result = await ProductListRequestHandler.fetchProductList(this.shopId, this.requestParams);

    this.filter.applyFilterResult(result.availableFilters);
    this.items = result.itemContent;
    this.total = result.totalSearchHits;

    return result;
  }
}
